export { ReactComponent as TextDirectionRTL } from './svgs/text-direction-rtl.svg';
